module.exports = __webpack_public_path__ + "img/icon-circle-left.a73d53a.png";